<template>
  <span class="text-text1 inline-flex items-center gap-4">{{ text }}<div v-show="isCopied" ref="lottieRef" class="w16 h16 inline-flex" /><SvgIcon v-show="!isCopied" class="w12 h12 cursor-pointer text-text3" icon="16-Line-Copy" @click="copy" /></span>
</template>

<script setup lang="ts">
import { useClipboard } from '@vueuse/core';
import { toast } from '@/utils/toast';
import json from './copy.json';

const { t } = useI18n();
const { copy: toClipboard } = useClipboard();
const isCopied = ref(false);  
const lottieRef = ref();
const lottieInstance = ref();

const props = defineProps({
  text: {
    type: String,
    required: true
  },
  copyText: {
    type: String,
    default: ''
  }
});

const playLottie = async() => {
  if (lottieInstance.value) {
    lottieInstance.value.stop();
    lottieInstance.value.play()?.catch(() => {
      // ignore
    });
  } else {
    const lottie = (await import('lottie-web')).default;
    lottieInstance.value = lottie.loadAnimation({
      container: lottieRef.value,
      renderer: 'svg',
      loop: false,
      autoplay: true,
      animationData: json
    });
    lottieInstance.value.setSpeed(3);
  }
};

const copy = async() => {
  await toClipboard(props.copyText || props.text);
  toast.success(t('复制成功'));
  isCopied.value = true;
  await playLottie();
  setTimeout(() => {
    isCopied.value = false;
  }, 3000);
};

</script>

<style lang="scss" module="style">
.errorBox {
  width: 432px;
  padding: 8px 12px;
  border-radius: 10px;
  background-color: var(--fill-fill4);
}

.detailBox {
  width: 432px;
  padding: 11.5px 15.5px;
  border-radius: 10px;
  border: 0.5px solid var(--border-border2);
}

.feeTag {
  height: 20px;
  padding: 4px;
  gap: 2px;
  border-radius: 4px;
  background-color: var(--primary-primary6);
  color: var(--primary-primary1);
}
</style>
